<template>
  <v-container style="padding-bottom:0px">
    <v-expansion-panels class="mt-4">
      <v-expansion-panel id="phone-numbers-panel">
        <v-expansion-panel-title><span style="color:#333333;">YOUR PHONE NUMBERS</span></v-expansion-panel-title>
        <v-expansion-panel-text>
          <div class="accordion-container">
            <h2>YOUR MAIN SYSTEM PHONE NUMBER IS {{ prettyPhone(company?.bbasMainPhone) }}.</h2>
            <p class="body-text">This number is yours exclusively. Forward your calls to this number when you want BBAS to automatically answer Jail calls and Bail calls. Unforward when you want to answer calls yourself.</p>

            <h2>&nbsp;</h2>
            <h2>To test your Jail calls menu call {{ prettyPhone(company?.menuDirectPhone) }}.</h2>
            <h2>To test your Bail calls (voicemail) menu call {{ prettyPhone(company?.voicemailPhone) }}.</h2>
            <h2>&nbsp;</h2>
            <p class="body-text">When calls come in to your Main System Phone we automatically detect whether it is a Jail call or a Bail call and send the call to the right place. On the main menu
            click <strong>SETTINGS / Voicemail and Forwarding</strong> to choose exactly what happens when a Jail call or Bail call comes in.</p>
            <h2>&nbsp;</h2>
            <h2>That's it. It's simple. <i style="color: #635347;">Never miss a single call with Bail Bond Agent Services.</i></h2>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import { prettyPhone } from '../utils/helpers';

export default {
  name: 'CompanyAccountYourPhoneNumbers',
  props: {
    company: {
      type: Object,
      required: true
    }
  },
  setup() {
    return {
      prettyPhone
    };
  }
};
</script>

<style scoped>
.accordion-container {
  background-color: #f5f5dc;
  padding: 20px;
  border-radius: 8px;
}

.standout {
  font-size: 18px;
  color: #333333;
  font-weight: bold;
}

.body-text {
  font-size: 18px;
  color: gray;
}

:deep(.v-expansion-panels > .v-expansion-panel > .v-expansion-panel-title) {
  font-size: 1.25rem !important;
  font-weight: 600 !important;
  color: #ffffff !important;
  background-color: #d2b48c !important;
  border: 1px solid #d2b48c !important;
}

:deep(.v-expansion-panels > .v-expansion-panel > .v-expansion-panel-title .v-expansion-panel-title__icon .v-icon) {
  color: #ffffff !important;
}

:deep(.v-expansion-panel-text) {
  background-color: #f5f5dc !important;
  border: 1px solid #d2b48c !important;
  border-top: none !important;
}

#phone-numbers-panel {
  margin-bottom: 4px;
}

@media (max-width: 600px) {
  .accordion-container {
    padding: 12px;
  }
  
  :deep(.v-expansion-panel-text__wrapper) {
    padding: 0;
  }
}
</style>
